import React, { useEffect, useState } from "react";
import Api from "../../services/ApiService";
import { Typeahead } from "react-bootstrap-typeahead";

/**
 * Autocomplete field for streets
 * ---------------------------------
 * fetches data from public api of available streets with data
 * passed to api. Uses then this fetched data for auto complition.
 * 
 * @param {string} zip data zip
 * @param {string} country Odoo numeric country codes
 * @param {string} city data city
 * @param {string} street value of field
 * @param {Setter} setStreet setter for field in data
 * @param {boolean} isError display if error was on field
 * 
 * @returns html autocomplete field 
 */
const StreetAutocomplete = ({zip, country, city, street, setStreet, isError, disabled}) => {

    const PUBLIC_API = new Api();
    const [streets, setStreets] = useState([]);

    // * when value of field changes
    useEffect(() => {
        // if str length is greater then 2 fetch data
        if (street !== undefined && street.length > 2) {
            fetchStreetsApi();
        }
    }, [street])

    // * fetch streets from api
    const fetchStreetsApi = () => {
        // fetch data from api
        PUBLIC_API.fetchStreets(country, zip, street, city)
            .then(res => {
                // if data isn't empty
                if (res.data.length > 0) {
                    var tempList = []; // temp array 

                    // loop through elements in data
                    res.data.forEach(s => {
                        // apppend if not in array and doesn't include "U-Bahn " or "Bahhof "
                        if (!tempList.includes(s.name) && !s.name.includes("U-Bahn ") && !s.name.includes("Bahnhof ")) {
                            tempList.push(s.name);
                        }
                    });
                    setStreets(tempList); // set state with temp array

                // if no data add entered to state
                } else {
                    setStreets([street]);
                }
            })
    }


    return (
        <Typeahead
            id="street-ac"
            style={{height: "56px"}}
            placeholder="Straße"
            defaultInputValue={street}
            onInputChange={(text, e) => setStreet(text)}
            onChange={e => setStreet(e[0])}
            options={streets}
            isValid={(streets.length > 0 && streets.includes(street)) || (streets.length === 0 && street !== undefined && street.length > 3)}
            isInvalid={isError}
            disabled={disabled}
        />
    )
}
export default StreetAutocomplete;